import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormBuilder, FormGroup, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Admin, Site } from '@app-models/site';
import { AuthService } from '@app-services/auth.service';
import { ParentErrorStateMatcher, identityValidator, checkInvalid } from '../../../validation';
import { errorMessages } from '../../../../message/error';
import { SiteService } from '@app-services/site.service';
import { LoadingScreenService } from '@app-services/loading-screen.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {

  _e = errorMessages.TH;
  fg: FormGroup;
  pFG: FormGroup;
  newAdmin: Admin;
  passwordMatcher: ErrorStateMatcher = new ParentErrorStateMatcher();
  curSite: Site;
  @ViewChild('form') formElementRef: ElementRef;

  constructor(
    public dialogUserRef: MatDialogRef<AddUserComponent>,
    @Inject(MAT_DIALOG_DATA) public siteId: string,
    private _fb: FormBuilder,
    private authSer: AuthService,
    private _ss: SiteService,
    private _ls: LoadingScreenService) { }

  async ngOnInit() {
    
    this.newAdmin = this._ss.newAdmin();
    this.pFG = this._fb.group({
      password: [null, [Validators.required, Validators.minLength(6)]],
      confirmPassword: [null, [Validators.required]]
    }, { validators: [identityValidator('password', 'confirmPassword')] });
    this.fg = this._fb.group({
      name: [this.newAdmin.name, Validators.required],
      email: [this.newAdmin.email, [Validators.required, Validators.email]],
      phoneNumber: [this.newAdmin.phoneNumber, Validators.required],
      pwd: this.pFG
    });
    this.curSite = await this._ss.getCurrentSite();
  }

  onSubmit(): void {
    this.fg.markAsTouched();
    this.pFG.markAsTouched();
    this.fg.markAsDirty();
    this.pFG.markAsDirty();
    if (!checkInvalid([this.fg, this.pFG], this.formElementRef, true)) {
      this._ls.startLoading();
      Object.assign(this.newAdmin, this.fg.value);
      this.authSer.createUser(this.newAdmin.email, this.pFG.get('password').value).then(
        (uid: string) => {
          this.newAdmin.id = uid;
          delete this.newAdmin['pwd'];
          this._ss.addAdmin(this.curSite.id, this.newAdmin).then(
            (value: any) => {
              this._ss.addLocalAdmin(this.newAdmin);
              this._ls.stopLoading();
              this.dialogUserRef.close(true);
            }
          ).finally(() => { this._ls.stopLoading(); });
        }
      ).catch(
        (error) => {
          if (error.code === 'auth/email-already-in-use') {
            this.fg.get('email').setErrors({ 'existed': true });
            this.fg.get('email').markAsTouched();
          } else if (error.code === 'auth/invalid-email') {
            this.fg.get('email').setErrors({ 'invalidEmail': true });
            this.fg.get('email').markAsTouched();
          } else {
            console.log(error);
          }
          this._ls.stopLoading();
        }
      );
    }
  }
}
